const store = require('Store');
const Storage = require('utils/localStorage/Storage');
const userUtils = require('utils/User');
const jsUtils = require('utils/javascript');

// If we haven't already cached the data, cache it
if (Storage.session.getItem && Storage.session.getItem('lastDataForBraze') === null) {
    let stubData = {
        'birth': '',
        'biStatus': '',
        'brazeEmail': '',
        'current_points': 0,
        'flash_membership_cancel_date': null,
        'flash_membership_expiry_date': null,
        'flash_membership_status': '',
        'itemsInBasket': 0,
        'user_id': '',
        'ytd_spend_amount': 0
    };
    Storage.session.setItem('lastDataForBraze', JSON.stringify(stubData));
}

let isNewData = function(key, value) {
    let cachedData = Storage.session.getItem('lastDataForBraze');
    let jsonCachedData = JSON.parse(cachedData);
    if (jsonCachedData[key] !== value) {
        return true;
    }
    return false;
};

// Sets only updated data in storage so redundant values are not sent to Braze
let setNewData = function(key, value) {
    if (isNewData(key, value)) {
        let cachedData = Storage.session.getItem('lastDataForBraze');
        let jsonCachedData = JSON.parse(cachedData);
        jsonCachedData[key] = value;
        let stringCachedData = JSON.stringify(jsonCachedData);
        Storage.session.setItem('lastDataForBraze', stringCachedData);
        return true;
    }
    return false;
};

let sendRegistrationData = function() {
    if (global.appboy) {
        let appboyUser = appboy.getUser();
        const { ccCardType, beautyInsiderAccount, profileId, bankRewards = {} } = store.getState().user;

        if (profileId) {
            appboy.changeUser(profileId);
        }

        if (beautyInsiderAccount !== undefined) {
            let { email,
                promotionPoints = 0,
                vibSegment,
                vibSpendingForYear = 0,
                ccAccountandPrescreenInfo = {} } = beautyInsiderAccount;

            if (!userUtils.isDefaultBIBirthDay(beautyInsiderAccount)) {
                let { birthYear, birthMonth, birthDay } = beautyInsiderAccount;
                if (setNewData('birth', birthYear+birthMonth+birthDay)) {
                    appboyUser.setDateOfBirth(parseInt(birthYear),
                        parseInt(birthMonth), parseInt(birthDay));
                }
            }

            if (setNewData('brazeEmail', email)) {
                appboyUser.setEmail(email);
            }

            if (setNewData('biStatus', vibSegment)) {
                appboyUser.setCustomUserAttribute('biStatus', vibSegment.toLowerCase());
                appboyUser.setCustomUserAttribute('current_points', promotionPoints);
            }

            if (!jsUtils.isObjectEmpty(ccAccountandPrescreenInfo)) {
                const { ccApprovalStatus, preScreenStatus } = ccAccountandPrescreenInfo;
                const prescreenedCardType = ccApprovalStatus === 'APPROVED' ? ccCardType : ccAccountandPrescreenInfo.prescreenedCardType;

                if (prescreenedCardType && setNewData('cc_type', prescreenedCardType)) {
                    appboyUser.setCustomUserAttribute('cc_type', prescreenedCardType);
                }
                if (setNewData('cc_approvalStatus', ccApprovalStatus)) {
                    appboyUser.setCustomUserAttribute('cc_approvalStatus', ccApprovalStatus);
                }
                if (setNewData('cc_preScreenStatus', preScreenStatus)) {
                    appboyUser.setCustomUserAttribute('cc_preScreenStatus', preScreenStatus);
                }
            }

            if (!jsUtils.isObjectEmpty(bankRewards)) {
                let ccRewardStatus = bankRewards.ccRewardStatus === 'CreditCard_REWARDS_ALREADY_REDEEMED' ? 'true' : 'false';
                if (setNewData('cc_rewardRedeemed', ccRewardStatus)) {
                    appboyUser.setCustomUserAttribute('cc_rewardRedeemed', ccRewardStatus);
                }
            } else {
                if (setNewData('cc_rewardRedeemed', 'false')) {
                    appboyUser.setCustomUserAttribute('cc_rewardRedeemed', 'false');
                }
            }

            appboyUser.setCustomUserAttribute('ytd_spend_amount', vibSpendingForYear);
        }
    }
};

module.exports = {
    setNewData,
    sendRegistrationData
};
